var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "63px",
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 30.5,
    cy: 30.5,
    r: 30.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("circle", {
    stroke: "#E1E1E1",
    cx: 30.5,
    cy: 30.5,
    r: 31
  }), /*#__PURE__*/React.createElement("g", {
    id: "university",
    mask: "url(#mask-2)",
    fill: "#929292",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.362069,15.8011374 L28.202931,15.8011374 L28.202931,14.2090995 C28.2025323,13.9765782 28.0782155,13.7622654 27.8775862,13.6483412 L19.137931,8.68530806 L19.137931,6.15867299 L20.8667241,6.15867299 L20.8667241,7.11905213 C20.8667241,7.47500474 21.1523578,7.7636019 21.5046552,7.7636019 L26.7165517,7.7636019 C27.0688491,7.76344076 27.3543233,7.47476303 27.3542435,7.11881043 C27.3542435,7.04420379 27.3413254,6.97016114 27.3162069,6.89990521 L26.7931034,5.39810427 L27.3225862,3.92853081 C27.4423578,3.59376777 27.2709138,3.22427962 26.9395884,3.1032654 C26.8701336,3.07788626 26.7968513,3.06491469 26.722931,3.06483412 L24.3498276,3.06483412 L24.3498276,2.13023697 C24.3498276,1.77428436 24.064194,1.4856872 23.7118966,1.4856872 L19.137931,1.4856872 L19.137931,0.699336493 C19.137931,0.343383886 18.8522974,0.0547867299 18.5,0.0547867299 C18.1477026,0.0547867299 17.862069,0.343383886 17.862069,0.699336493 L17.862069,8.68530806 L9.12241379,13.6418957 C8.92178448,13.7558199 8.79746767,13.9701327 8.79706897,14.202654 L8.79706897,15.7946919 L0.637931034,15.7946919 C0.285633621,15.7946919 0,16.0832891 0,16.4392417 L0,33.3006635 C0,33.6566161 0.285633621,33.9452133 0.637931034,33.9452133 L36.362069,33.9452133 C36.7143664,33.9452133 37,33.6566161 37,33.3006635 L37,16.4456872 C37,16.0897346 36.7143664,15.8011374 36.362069,15.8011374 Z M24.3498276,5.51412322 L24.3243103,5.48834123 L24.3243103,4.37971564 L25.7787931,4.37971564 L25.5172414,5.20473934 C25.4650108,5.3483128 25.4650108,5.50590521 25.5172414,5.64947867 L25.817069,6.47450237 L22.1425862,6.47450237 L22.1425862,6.15867299 L23.7118966,6.15867299 C24.064194,6.15867299 24.3498276,5.87007583 24.3498276,5.51412322 Z M19.137931,2.77478673 L23.0739655,2.77478673 L23.0739655,3.73516588 L23.0739655,4.86957346 L19.137931,4.86957346 L19.137931,2.77478673 Z M8.79706897,32.6561137 L1.27586207,32.6561137 L1.27586207,17.090237 L8.79706897,17.090237 L8.79706897,32.6561137 Z M17.862069,32.6561137 L14.512931,32.6561137 L14.512931,25.2953555 L17.862069,25.2953555 L17.862069,32.6561137 Z M22.487069,32.6561137 L19.137931,32.6561137 L19.137931,25.2953555 L22.487069,25.2953555 L22.487069,32.6561137 Z M26.9525862,32.6561137 L23.762931,32.6561137 L23.762931,24.6508057 C23.762931,24.2948531 23.4772974,24.0062559 23.125,24.0062559 L13.875,24.0062559 C13.5227026,24.0062559 13.237069,24.2948531 13.237069,24.6508057 L13.237069,32.6561137 L10.0474138,32.6561137 L10.0474138,14.6087204 L18.5,9.80037915 L26.927069,14.5829384 L26.9525862,16.4392417 L26.9525862,32.6561137 Z M35.7241379,32.6561137 L28.202931,32.6561137 L28.202931,17.090237 L35.7241379,17.090237 L35.7241379,32.6561137 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,11.7727014 C17.0227112,11.7762464 15.827069,12.9871943 15.827069,14.4798104 C15.8305776,15.9713791 17.0301272,17.1775735 18.5063793,17.1740284 C19.9826315,17.1704834 21.1764397,15.9584882 21.172931,14.4669194 C21.1694224,12.9779289 19.9737004,11.7727014 18.5,11.7727014 Z M18.5,15.8849289 C17.7284224,15.8813839 17.1058017,15.2465024 17.1093103,14.4669194 C17.112819,13.6924123 17.7333664,13.065346 18.5,13.0618009 C19.2726142,13.065346 19.897069,13.6991801 19.897069,14.4798104 L19.9034483,14.4798104 C19.8999397,15.2593934 19.2715776,15.8884739 18.5,15.8849289 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "2.81327586 18.5082464 4.08913793 18.5082464 4.08913793 21.0864455 2.81327586 21.0864455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "5.95827586 18.5082464 7.23413793 18.5082464 7.23413793 21.0864455 5.95827586 21.0864455"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 11.9867241,
    y: 18.5082464,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 17.2241379,
    y: 18.5082464,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 22.4615517,
    y: 18.5082464,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 11.9867241,
    y: 21.5118483,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 17.2241379,
    y: 21.5118483,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 22.4615517,
    y: 21.5118483,
    width: 2.55172414,
    height: 1.28909953
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 2.81327586,
    y: 23.5808531,
    width: 1.27586207,
    height: 2.57819905
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 5.95827586,
    y: 23.5808531,
    width: 1.27586207,
    height: 2.57819905
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "2.81327586 28.6599052 4.08913793 28.6599052 4.08913793 31.2381043 2.81327586 31.2381043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "5.95827586 28.6599052 7.23413793 28.6599052 7.23413793 31.2381043 5.95827586 31.2381043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "29.7658621 18.5082464 31.0417241 18.5082464 31.0417241 21.0864455 29.7658621 21.0864455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "32.9108621 18.5082464 34.1867241 18.5082464 34.1867241 21.0864455 32.9108621 21.0864455"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 29.7658621,
    y: 23.5808531,
    width: 1.27586207,
    height: 2.57819905
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 32.9108621,
    y: 23.5808531,
    width: 1.27586207,
    height: 2.57819905
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "29.7658621 28.6599052 31.0417241 28.6599052 31.0417241 31.2381043 29.7658621 31.2381043"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    points: "32.9108621 28.6599052 34.1867241 28.6599052 34.1867241 31.2381043 32.9108621 31.2381043"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsticon);
export default __webpack_public_path__ + "static/media/insticon.a52057bd7603f4c5136b4591b35f0ae0.svg";
export { ForwardRef as ReactComponent };